import { Box } from "@mui/material";
import { ClipLoader } from "react-spinners";

export const Loader = ({ color = "#0F110C", size = 24 }) => {
  return (
    <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
      <ClipLoader color={color} size={size} />
    </Box>
  );
};
